import React from "react";

export default function TransactionReferenceText({
	referenceText,
}: {
	referenceText?: string | null;
}) {
	if (!referenceText) {
		return null;
	}

	return (
		<div className="u-type--xsml u-type--wgt--regular u-color--text--tertiary u-mar--top--xsml">
			{referenceText}
		</div>
	);
}
